import styled from '../utils/styled-components-wrapper.js'
import { Popover } from '../popover/index.js'

export const TooltipPopoverStyle = styled(Popover)`
  && {
    padding: 12px;
    background: var(--lido-color-accent);
    color: var(--lido-color-accentContrast);
    font-size: ${({ theme }) => theme.fontSizesMap.xxxs}px;
    line-height: 1.8em;
    font-weight: 400;
    max-width: 256px;
    border-radius: ${({ theme }) => theme.borderRadiusesMap.md}px;
    box-shadow: ${({ theme }) => theme.boxShadows.sm}
      var(--lido-color-shadowLight);
  }
`
